module.exports = __webpack_public_path__ + "assets/img/h5.cd7fb514.png";